import { BrowserRouter } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { HelmetProvider } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { getToken, onMessage } from 'firebase/messaging';
import { messaging } from './firebaseConfig';
import LoginPage from './pages/LoginPage';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';
import appConfig from './config';

import 'react-toastify/dist/ReactToastify.css';
import FloatingTimeCard from './components/FloatingTimeCard';
// ----------------------------------------------------------------------
// basename="/moodlift-admin"
export default function App() {
  const storedUser = localStorage.getItem('technisches');
  const parsedUser = storedUser ? JSON.parse(storedUser) : null;
  const isLocalSessionExpired = parsedUser?.expiresAt && new Date(parsedUser.expiresAt).getTime() <= Date.now();
  if (isLocalSessionExpired) {
    localStorage.removeItem('technisches');
  }
  const user = isLocalSessionExpired ? null : storedUser;
  const [isLoggedin, setIsLoggedin] = useState(user);
  const [showTimeCard, setShowTimeCard] = useState(true);

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/firebase-messaging-sw.js')
        .then((registration) => {
          console.log('Service Worker registered successfully:', registration);
        })
        .catch((error) => {
          console.error('Service Worker registration failed:', error);
        });
    }

    const subscribeToTopic = async () => {
      try {
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') {
          console.error('Permission for notifications was denied.');
          return;
        }
        const vapidKey = 'BJ8cLEzdxbAcAvmCC51hM1BMGluSeduSF6Zt2-4H7pjpwTsLAqnnCYEFcdWrMZ1yCPpULh-F_qwfBcFJY4zz0zo'; // Replace with your Firebase VAPID key
        const topic = 'test'; // Replace with your desired topic

        // Request FCM token
        const registrationToken = await getToken(messaging, { vapidKey });
        if (registrationToken) {
          console.log('FCM Registration Token:', registrationToken);

          // Send token and topic to backend to subscribe
          await fetch(`${appConfig.API_URL}/user/subscribe-topic`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ registrationToken, topic }),
          });

          console.log(`Subscribed to topic: ${topic}`);
        } else {
          console.warn('No registration token available. Request permission to generate one.');
        }
      } catch (error) {
        console.error('Error subscribing to topic:', error);
      }
    };

    subscribeToTopic();

    // Listen for foreground messages
    // onMessage(messaging, (payload) => {
    //   console.log("Foreground notification received:", payload);
    //   alert(`Notification: ${payload.notification.title}`);
    // });
  }, []);

  useEffect(() => {
    onMessage(messaging, async (payload) => {
      console.log('Background notification received:', payload);
      if (Notification.permission === 'granted') {
        const { title, body, icon } = payload.notification;
        // new Notification(title, {
        //   body,
        //   icon,
        // });
        // await toast.info(`New message: ${payload.notification.body.slice(0, 20)}`, {
        //   style: { fontSize: "15px" },
        // });
      }
    });
  });

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <HelmetProvider>
        <BrowserRouter
        //  basename="/Technisches-Handbuch-Admin/"
        >
          <ThemeProvider>
            <ScrollToTop />
            <ToastContainer />
            <StyledChart />
            {isLoggedin ? <Router /> : <LoginPage />}
            {showTimeCard && <FloatingTimeCard onClose={() => setShowTimeCard(false)} />}
          </ThemeProvider>
        </BrowserRouter>
      </HelmetProvider>
    </LocalizationProvider>
  );
}
